module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1475.932f459e.svg";